import { On3IconLockOutline } from '@on3/icons';
import clsx from 'clsx';
import Link from 'next/link';

import styles from './RpmBarrier.module.scss';

export enum RpmUtmCampaigns {
  List = 'list_rpms',
  Player = 'player_rpms',
  Expert = 'expert_rpms',
  Team = 'team_rpms',
}

interface IRpmBarrierProps {
  className?: string;
  utm_campaign: RpmUtmCampaigns;
}
export const RpmBarrier = ({ className, utm_campaign }: IRpmBarrierProps) => {
  const joinLink = `/subscribe/`;

  const params = new URLSearchParams({
    utm_source: 'premium_rpms',
    utm_medium: 'web',
    utm_campaign,
    utm_content: 'join_link',
  });

  const utmLink = `${joinLink}?${params}`;

  return (
    <Link className={clsx(styles.rpmBarrier, className)} href={utmLink}>
      <On3IconLockOutline />
      <div className={styles.block}>
        <div className={styles.membersOnly}>
          <span>Insider Pick</span>
          <span>Locked</span>
        </div>
        <div className={styles.callout}>
          <span>Join now</span>
          <span>to reveal expert picks</span>
        </div>
      </div>
    </Link>
  );
};
